<script setup lang="ts">
import HeadingLv4 from '@shared/components/atoms/ArticleContents/HeadingLv4.vue';
import TagIcon from 'vue-material-design-icons/Tag.vue';
import { splitStringByComma } from '@shared/utils/splitStringByComma';

const props = defineProps({
  tags: {
    required: true,
    type: String,
  },
});

const tagsArray = computed<string[]>(() => {
  return splitStringByComma(props.tags);
});
</script>

<template>
  <div v-if="tagsArray.length" class="mb-10">
    <HeadingLv4>関連キーワード</HeadingLv4>

    <div class="flex gap-3 flex-wrap">
      <NuxtLink
        v-for="tag in tagsArray"
        :key="tag"
        :to="{
          path: '/public/article/news',
          query: {
            tag,
          },
        }"
        class="flex rounded border border-gray-400 py-1 px-2 hover:opacity-70 hover:underline duration-300"
      >
        <TagIcon :size="20" class="shrink-0 mr-1" />
        <span>{{ tag }}</span>
      </NuxtLink>
    </div>
  </div>
</template>
